/**
 * TrusCont DRM notice popup — global interceptor.
 * Loaded once on every page (see layout/theme.liquid). Works together with
 * snippets/truscont-drm-popup.liquid, which renders the modal markup only
 * on truscont-tagged products, and a data-truscont="true" attribute set on
 * that product's form container (main-product.liquid, product-info.liquid,
 * product-card.liquid).
 *
 * On submit of a /cart/add form nested inside a data-truscont="true"
 * container, blocks the add-to-cart until the buyer confirms the popup,
 * then re-submits the same form.
 */
(function () {
  var pendingForm = null;
  var pendingSubmitter = null;

  function isAddToCartForm(form) {
    return form && form.tagName === 'FORM' && (form.action || '').indexOf('/cart/add') !== -1;
  }

  function findModalFor(form) {
    var scope = form.closest('[data-truscont="true"]');
    if (scope) {
      var scoped = scope.querySelector('.truscont-drm-modal');
      if (scoped) return scoped;
    }
    return document.querySelector('.truscont-drm-modal');
  }

  function showModal(modal, form, submitter) {
    pendingForm = form;
    pendingSubmitter = submitter;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
  }

  function hideModal(modal) {
    if (modal) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
    }
  }

  // Capture phase: runs before the theme's own submit handler, so we can
  // block it with stopImmediatePropagation until the buyer confirms.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isAddToCartForm(form)) return;

    if (form.dataset.truscontConfirmed === 'true') {
      delete form.dataset.truscontConfirmed;
      return; // let this one through — it's the re-submit after confirmation
    }

    if (!form.closest('[data-truscont="true"]')) return;

    var modal = findModalFor(form);
    if (!modal) return; // tagged but markup missing somehow — fail open

    event.preventDefault();
    event.stopImmediatePropagation();
    showModal(modal, form, event.submitter);
  }, true);

  document.addEventListener('click', function (event) {
    var dismissEl = event.target.closest('[data-truscont-dismiss]');
    if (dismissEl) {
      hideModal(dismissEl.closest('.truscont-drm-modal'));
      pendingForm = null;
      pendingSubmitter = null;
      return;
    }

    var continueEl = event.target.closest('[data-truscont-continue]');
    if (continueEl) {
      hideModal(continueEl.closest('.truscont-drm-modal'));
      if (!pendingForm) return;
      pendingForm.dataset.truscontConfirmed = 'true';
      if (typeof pendingForm.requestSubmit === 'function') {
        pendingForm.requestSubmit(pendingSubmitter || undefined);
      } else {
        pendingForm.submit();
      }
      pendingForm = null;
      pendingSubmitter = null;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.truscont-drm-modal').forEach(function (modal) {
      if (!modal.hidden) hideModal(modal);
    });
  });
})();
